/** @format */

import axios from "axios";
import React, { useEffect, useState } from "react";
import {
  SettingOutlined,
  CloseOutlined,
  SaveOutlined,
} from "@ant-design/icons";

import Fixer from "./fixer";
import { header } from "../../../../../../components/api/Header";
import LoadingCard from "../../../../../../components/loading/loadingCard";
import { getEnv } from "../../../../../../lib/env";

const hcols = [
  0, //Hudud nomi 0
  2, //04.01-2025 1
  2, //kunlik Suv sarfi 2
  2, //jami sug'orish 3
  1, //Reja 4
  1, //1kunda 5
  1, //1.04.25 dan boshlab 6
  1, //Baxorgi sug'orish 7
  1, //Jami ekilgandan boshlab 8
  2, //1-suv G'alla 9
  2, //2-suv 10
  2, //3-suv 11
  2, //4-suv 12
  2, //5-suv 13
  3, //Baxorgi sho'r yuvish 14
  3, //G'ozaga Pushti va nam suvi berish ishlari 15
  2, //Chigit suvi 16
  1, //Reja 17
  1, //1 kunda 18
  1, //Jami 19
  2, //1-suv Go'za 20
  2, //2-suv 21
  2, //3-suv 22
  2, //4-suv 23
  2, //5-suv 24
  2, //6-suv 25
  2, //Takroriy ekin sug‘orish 26
  2, //2026-yil xosili uchun G'alla ekishdan oldingi sho'r yuvish va nam 27
  2, //2026-yil xosili uchun G'alla sug'orish 28
  2, //Ochiq maydon 29
  2, //G‘o‘za qator orasi 30
  2, //Tomorqa va boshqa sug'orish ishlari 31
  1, //1 kunda olingan suv bilan sug'orish mumkin bo'lgan maydon, ming ga 32
  1, //SFK 33
  1, //Sug‘orish ishlarida qatnashgan suvchilar soni 34
];

const bcols = Array(58).fill(1);

function Table({ date }) {
  const [c, setC] = useState(hcols);
  const [bc, setBc] = useState(bcols);
  const [data, setData] = useState([]);
  const [menu, setMenu] = useState(false);
  const [loading, setLoading] = useState(false);
  const [year, month, day] = date.split("-");

  const regions = [
    "Qoraqalpog‘iston Respublikasi",
    "Andijon",
    "Buxoro",
    "Jizzax",
    "Qashqadaryo",
    "Navoiy",
    "Namangan",
    "Samarqand",
    "Surxondaryo",
    "Sirdaryo",
    "Toshkent",
    "Farg‘ona",
    "Xorazm",
    "Jami",
    `${Number(year) - 1} - yil`,
  ];

  const saveHandler = async () => {
    try {
      const res = await axios.post(
        getEnv('REACT_APP_BASE_URL') + "/v1/republik/sugorish/savecontrol",
        { c, bolim: "vegetatsiya", bc },
        header()
      );
      if (res && res.data.length > 1) {
        setC(res.data);
      }
    } catch (e) {
      console.log("Xato", e);
      alert("Serverga bog'lanishda xato");
    }
  };

  useEffect(() => {
    if (!date) return;

    const fetchAllData = async () => {
      setLoading(true);

      try {
        const vegCrudPromise = axios.get(
          `${getEnv('REACT_APP_BASE_URL')}/v1/republik/sugorish/vegcrud?sana=${date}`,
          header()
        );

        const vegetatsiyaPromise = axios.get(
          `${getEnv('REACT_APP_BASE_URL')}/v1/republik/sugorish/vegetatsiya?date=${date}`,
          header()
        );

        const [vegCrudRes, vegetatsiyaRes] = await Promise.all([
          vegCrudPromise,
          vegetatsiyaPromise,
        ]);

        setData(vegCrudRes?.data?.data || []);

        const vData = vegetatsiyaRes?.data;
        if (vData?.controls?.length > 1) setC(vData.controls);
        if (vData?.bodyc?.length > 1) setBc(vData.bodyc);
      } catch (error) {
        console.error("❌ Xatolik yuz berdi:", error);
        alert("Server bilan bog‘lanishda xatolik");
      } finally {
        setLoading(false);
      }
    };

    fetchAllData();
  }, [date]);

  const fixValue = (value) => {
    const fixedValue = value === "" ? "" : Number(value).toFixed(1);

    return fixedValue;
  };

  return (
    <div className='table-responsive tableFixHead controllable-table-block'>
      {menu ? (
        <div className='table-controls-close active d-flex justify-content-between'>
          <button
            className='btn btn-sm btn-outline-primary d-flex align-items-center'
            onClick={() => saveHandler()}>
            Saqlash &nbsp;&nbsp;
            <SaveOutlined />
          </button>

          <CloseOutlined
            className='btn btn-secondary btn-sm'
            onClick={() => setMenu(false)}
          />
        </div>
      ) : (
        <div className='table-controls-open active'>
          <SettingOutlined
            className='btn btn-secondary'
            onClick={() => setMenu(true)}
          />
        </div>
      )}

      <div
        className={menu ? "table-controls-menu active" : "table-controls-menu"}>
        <Fixer c={c} setC={setC} bc={bc} setBc={setBc} />
      </div>

      {loading ? (
        <LoadingCard heightSize='80vh' loading={loading} />
      ) : (
        <div id='tableFlexible'>
          <div style={{ width: "100%" }}>
            <table
              className='table table-bordered table-style'
              id='controllable'>
              <thead>
                <tr>
                  <th rowSpan='6' className='st1 sticky'>
                    T/r
                  </th>

                  <th rowSpan='6' className='st1 sticky'>
                    Hududlar nomi
                  </th>

                  <th
                    colSpan={c[1] + c[2]}
                    className={c[1] + c[2] == 0 ? "hidden" : ""}>
                    Sug‘orish ishlariga olingan suv miqdori
                  </th>

                  <th
                    colSpan={sum(
                      c,
                      [
                        3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18,
                        19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30,
                      ]
                    )}
                    className={
                      sum(
                        c,
                        [
                          3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17,
                          18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30,
                        ]
                      ) == 0
                        ? "hidden"
                        : ""
                    }>
                    Sug‘orilgan maydon, ming ga
                  </th>

                  <th
                    rowSpan='3'
                    colSpan={c[31]}
                    className={c[31] == 0 ? "hidden" : ""}>
                    Tomorqa va boshqa sug'orish ishlari
                  </th>

                  <th
                    rowSpan='6'
                    style={{
                      width: "120px",
                      maxWidth: "120px",
                      minWidth: "120px",
                    }}
                    className={c[32] == 0 ? "hidden" : ""}>
                    1 kunda olingan suv bilan sug'orish mumkin bo'lgan maydon,
                    ming ga
                  </th>

                  <th rowSpan='6' className={c[33] == 0 ? "hidden" : ""}>
                    SFK
                  </th>

                  <th rowSpan='6' className={c[34] == 0 ? "hidden" : ""}>
                    Sug‘orish ishlarida qatnashgan suvchilar soni
                  </th>
                </tr>

                <tr>
                  <th
                    colSpan={c[1]}
                    rowSpan='2'
                    className={c[1] == 0 ? "hidden" : ""}>
                    01.04-30.09.{year} y. mln.m3
                  </th>

                  <th
                    colSpan={c[2]}
                    rowSpan='2'
                    className={c[2] == 0 ? "hidden" : ""}>
                    Kunlik suv sarfi m3/s.
                  </th>

                  <th
                    colSpan={c[3]}
                    rowSpan='2'
                    className={c[3] == 0 ? "hidden" : ""}>
                    Jami sug‘orish ishlari
                  </th>

                  <th
                    colSpan={sum(
                      c,
                      [
                        4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18,
                        19, 20, 21, 22, 23, 24, 25, 26,
                      ]
                    )}
                    className={
                      sum(
                        c,
                        [
                          4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18,
                          19, 20, 21, 22, 23, 24, 25, 26,
                        ]
                      ) == 0
                        ? "hidden"
                        : ""
                    }>
                    Shundan
                  </th>

                  <th
                    colSpan={c[27]}
                    className={c[27] == 0 ? "hidden" : ""}
                    rowSpan='2'>
                    {Number(year) + 1}-yil xosili uchun g'alla ekishdan oldingi
                    sho'r yuvish va nam
                  </th>

                  <th
                    colSpan={c[28]}
                    className={c[28] == 0 ? "hidden" : ""}
                    rowSpan='2'>
                    {Number(year) + 1}-yil xosili uchun g'alla sug'orish
                  </th>

                  <th
                    colSpan={sum(c, [29, 30])}
                    className={sum(c, [29, 30]) == 0 ? "hidden" : ""}>
                    Shu jumladan
                  </th>
                </tr>

                <tr>
                  <th
                    colSpan={sum(c, [4, 5, 6, 7, 8, 9, 10, 11, 12, 13])}
                    className={
                      sum(c, [4, 5, 6, 7, 8, 9, 10, 11, 12, 13]) == 0
                        ? "hidden"
                        : ""
                    }>
                    G‘alla sug‘orish
                  </th>

                  <th colSpan={c[14]} className={c[14] == 0 ? "hidden" : ""}>
                    Baxorgi sho'r yuvish
                  </th>

                  <th colSpan={c[15]} className={c[15] == 0 ? "hidden" : ""}>
                    G'ozaga pushta va nam suvi berish ishlari
                  </th>

                  <th colSpan={c[16]} className={c[16] == 0 ? "hidden" : ""}>
                    Chigit suvi
                  </th>

                  <th
                    colSpan={sum(c, [17, 18, 19, 20, 21, 22, 23, 24, 25])}
                    className={
                      sum(c, [17, 18, 19, 20, 21, 22, 23, 24, 25]) == 0
                        ? "hidden"
                        : ""
                    }>
                    G‘o‘za sug‘orish
                  </th>

                  <th colSpan={c[26]} className={c[26] == 0 ? "hidden" : ""}>
                    Takroriy ekin sug‘orish
                  </th>

                  <th colSpan={c[29]} className={c[29] == 0 ? "hidden" : ""}>
                    Ochiq maydon
                  </th>

                  <th colSpan={c[30]} className={c[30] == 0 ? "hidden" : ""}>
                    G‘o‘za qator orasi
                  </th>
                </tr>

                <tr>
                  <th rowSpan='3' className={c[1] == 0 ? "hidden" : ""}>
                    Limit
                  </th>

                  <th rowSpan='3' className={c[1] == 0 ? "hidden" : ""}>
                    Amalda
                  </th>

                  <th rowSpan='3' className={c[2] == 0 ? "hidden" : ""}>
                    Limit
                  </th>

                  <th rowSpan='3' className={c[2] == 0 ? "hidden" : ""}>
                    Amalda
                  </th>

                  <th rowSpan='3' className={c[3] == 0 ? "hidden" : ""}>
                    1 kunda
                  </th>

                  <th rowSpan='3' className={c[3] == 0 ? "hidden" : ""}>
                    Jami
                  </th>

                  <th rowSpan='3' className={c[4] == 0 ? "hidden" : ""}>
                    Reja
                  </th>

                  <th rowSpan='3' className={c[5] == 0 ? "hidden" : ""}>
                    1 kunda
                  </th>

                  <th rowSpan='3' className={c[6] == 0 ? "hidden" : ""}>
                    01.04.{year} dan boshlab
                  </th>

                  <th rowSpan='3' className={c[7] == 0 ? "hidden" : ""}>
                    Baxorgi sug'orish
                  </th>

                  <th rowSpan='3' className={c[8] == 0 ? "hidden" : ""}>
                    Jami ekilgandan boshlab
                  </th>

                  <th
                    colSpan={sum(c, [9, 10, 11, 12, 13])}
                    className={
                      sum(c, [9, 10, 11, 12, 13]) == 0 ? "hidden" : ""
                    }>
                    Shu jumladan
                  </th>

                  <th rowSpan='3' className={c[14] == 0 ? "hidden" : ""}>
                    Reja
                  </th>

                  <th rowSpan='3' className={c[14] == 0 ? "hidden" : ""}>
                    1 kunda
                  </th>

                  <th rowSpan='3' className={c[14] == 0 ? "hidden" : ""}>
                    Jami
                  </th>

                  <th rowSpan='3' className={c[15] == 0 ? "hidden" : ""}>
                    Reja
                  </th>

                  <th rowSpan='3' className={c[15] == 0 ? "hidden" : ""}>
                    1 kunda
                  </th>

                  <th rowSpan='3' className={c[15] == 0 ? "hidden" : ""}>
                    Jami
                  </th>

                  <th rowSpan='3' className={c[16] == 0 ? "hidden" : ""}>
                    1 kunda
                  </th>

                  <th rowSpan='3' className={c[16] == 0 ? "hidden" : ""}>
                    Jami
                  </th>

                  <th rowSpan='3' className={c[17] == 0 ? "hidden" : ""}>
                    Reja
                  </th>

                  <th rowSpan='3' className={c[18] == 0 ? "hidden" : ""}>
                    1 kunda
                  </th>

                  <th rowSpan='3' className={c[19] == 0 ? "hidden" : ""}>
                    Jami
                  </th>

                  <th
                    colSpan={sum(c, [20, 21, 22, 23, 24, 25])}
                    className={
                      sum(c, [20, 21, 22, 23, 24, 25]) == 0 ? "hidden" : ""
                    }>
                    Shundan
                  </th>

                  <th rowSpan='3' className={c[26] == 0 ? "hidden" : ""}>
                    1 kunda
                  </th>

                  <th rowSpan='3' className={c[26] == 0 ? "hidden" : ""}>
                    Jami
                  </th>

                  <th rowSpan='3' className={c[27] == 0 ? "hidden" : ""}>
                    1 kunda
                  </th>

                  <th rowSpan='3' className={c[27] == 0 ? "hidden" : ""}>
                    Jami
                  </th>

                  <th rowSpan='3' className={c[28] == 0 ? "hidden" : ""}>
                    1 kunda
                  </th>

                  <th rowSpan='3' className={c[28] == 0 ? "hidden" : ""}>
                    Jami
                  </th>

                  <th rowSpan='3' className={c[29] == 0 ? "hidden" : ""}>
                    1 kunda
                  </th>

                  <th rowSpan='3' className={c[29] == 0 ? "hidden" : ""}>
                    Jami
                  </th>

                  <th rowSpan='3' className={c[30] == 0 ? "hidden" : ""}>
                    1 kunda
                  </th>

                  <th rowSpan='3' className={c[30] == 0 ? "hidden" : ""}>
                    Jami
                  </th>

                  <th rowSpan='3' className={c[31] == 0 ? "hidden" : ""}>
                    1 kunda
                  </th>

                  <th rowSpan='3' className={c[31] == 0 ? "hidden" : ""}>
                    Jami
                  </th>
                </tr>

                <tr>
                  <th colSpan={c[9]} className={c[9] == 0 ? "hidden" : ""}>
                    1-suv
                  </th>

                  <th colSpan={c[10]} className={c[10] == 0 ? "hidden" : ""}>
                    2-suv
                  </th>

                  <th colSpan={c[11]} className={c[11] == 0 ? "hidden" : ""}>
                    3-suv
                  </th>

                  <th colSpan={c[12]} className={c[12] == 0 ? "hidden" : ""}>
                    4-suv
                  </th>

                  <th colSpan={c[13]} className={c[13] == 0 ? "hidden" : ""}>
                    5-suv
                  </th>

                  <th colSpan={c[20]} className={c[20] == 0 ? "hidden" : ""}>
                    1-suv
                  </th>

                  <th colSpan={c[21]} className={c[21] == 0 ? "hidden" : ""}>
                    2-suv
                  </th>

                  <th colSpan={c[22]} className={c[22] == 0 ? "hidden" : ""}>
                    3-suv
                  </th>

                  <th colSpan={c[23]} className={c[23] == 0 ? "hidden" : ""}>
                    4-suv
                  </th>

                  <th colSpan={c[24]} className={c[24] == 0 ? "hidden" : ""}>
                    5-suv
                  </th>

                  <th colSpan={c[25]} className={c[25] == 0 ? "hidden" : ""}>
                    6-suv
                  </th>
                </tr>

                <tr>
                  <th className={c[9] == 0 ? "hidden" : ""}>1 kunda</th>
                  <th className={c[9] == 0 ? "hidden" : ""}>jami</th>
                  <th className={c[10] == 0 ? "hidden" : ""}>1 kunda</th>
                  <th className={c[10] == 0 ? "hidden" : ""}>jami</th>
                  <th className={c[11] == 0 ? "hidden" : ""}>1 kunda</th>
                  <th className={c[11] == 0 ? "hidden" : ""}>jami</th>
                  <th className={c[12] == 0 ? "hidden" : ""}>1 kunda</th>
                  <th className={c[12] == 0 ? "hidden" : ""}>jami</th>
                  <th className={c[13] == 0 ? "hidden" : ""}>1 kunda</th>
                  <th className={c[13] == 0 ? "hidden" : ""}>jami</th>
                  <th className={c[20] == 0 ? "hidden" : ""}>1 kunda</th>
                  <th className={c[20] == 0 ? "hidden" : ""}>jami</th>
                  <th className={c[21] == 0 ? "hidden" : ""}>1 kunda</th>
                  <th className={c[21] == 0 ? "hidden" : ""}>jami</th>
                  <th className={c[22] == 0 ? "hidden" : ""}>1 kunda</th>
                  <th className={c[22] == 0 ? "hidden" : ""}>jami</th>
                  <th className={c[23] == 0 ? "hidden" : ""}>1 kunda</th>
                  <th className={c[23] == 0 ? "hidden" : ""}>jami</th>
                  <th className={c[24] == 0 ? "hidden" : ""}>1 kunda</th>
                  <th className={c[24] == 0 ? "hidden" : ""}>jami</th>
                  <th className={c[25] == 0 ? "hidden" : ""}>1 kunda</th>
                  <th className={c[25] == 0 ? "hidden" : ""}>jami</th>
                </tr>
              </thead>

              {data.length > 0 ? (
                regions.map((d, i) => {
                  return (
                    <tbody key={i}>
                      <tr>
                        {i === 13 || i === 14 ? (
                          <td className='sticky st1 fix-with'>{""}</td>
                        ) : (
                          <td className='sticky st1 fix-with'>{i + 1}</td>
                        )}
                        <td className='sticky st1 fix-with'>{d}</td>

                        {data[i]?.map((value, ind) => {
                          return (
                            <td
                              className={bc[ind] == 0 ? "hidden" : ""}
                              key={ind}>
                              {fixValue(value)}
                            </td>
                          );
                        })}
                      </tr>
                    </tbody>
                  );
                })
              ) : (
                <tbody>
                  {regions.map((d, i) => (
                    <tr key={i}>
                      {i === 13 || i === 14 ? (
                        <td className='sticky st1 fix-with'>{""}</td>
                      ) : (
                        <td className='sticky st1 fix-with'>{i + 1}</td>
                      )}
                      <td className='sticky st1 fix-with'>{d}</td>

                      {Array.from({ length: 59 }).map((_, ind) => (
                        <td className={bc[ind] == 0 ? "hidden" : ""} key={ind}>
                          {""}
                        </td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              )}
            </table>
          </div>
        </div>
      )}
    </div>
  );
}

export default Table;

const sum = (d, a) => {
  let s = 0;
  a.map((i) => (s += d[i]));
  return s;
};
